"use strict";
var Observable_1 = require('../../Observable');
var zipAll_1 = require('../../operator/zipAll');
Observable_1.Observable.prototype.zipAll = zipAll_1.zipAll;
//# sourceMappingURL=zipAll.js.map


//////////////////
// WEBPACK FOOTER
// /app/SPA/~/rxjs/add/operator/zipAll.js
// module id = ../../../../rxjs/add/operator/zipAll.js
// module chunks = 4